import { Box } from 'grommet'
import styled from 'styled-components'
import { large, small } from '../../common/assets/utils/_sizes'

export const IconBox = styled(Box)`
  margin-right: ${small};
  margin-left: ${large};
`
